import type { ReactNode } from 'react';
import type { EstadoTurno } from '@medchoice/shared';
import { Icono, type NombreIcono } from './Icono';

export type TonoInsignia =
  | EstadoTurno | 'info' | 'coral' | 'neutral' | 'nuevo' | 'admin';

interface PropsInsignia {
  tono?: TonoInsignia;
  tamano?: 'chico' | 'mediano' | 'grande';
  punto?: boolean;
  icono?: NombreIcono;
  children: ReactNode;
}

export function Insignia({ tono = 'neutral', tamano = 'mediano', punto, icono, children }: PropsInsignia) {
  return (
    <span className={`insignia insignia--${tono} insignia--${tamano}`}>
      {punto && <span className="insignia__punto" aria-hidden="true" />}
      {icono && <Icono nombre={icono} tamano={12} />}
      {children}
    </span>
  );
}

const TEXTO_ESTADO: Record<EstadoTurno, string> = {
  pendiente: 'Pendiente de pago',
  confirmado: 'Confirmado',
  atendido: 'Atendido',
  cancelado: 'Cancelado',
  ausente: 'No asistió',
};

export function InsigniaEstadoTurno({ estado, tamano = 'chico' }: {
  estado: EstadoTurno;
  tamano?: PropsInsignia['tamano'];
}) {
  return <Insignia tono={estado} tamano={tamano} punto>{TEXTO_ESTADO[estado]}</Insignia>;
}
